import { Checkbox, TableBody, TableCell } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import CustomHeading from '../../components/CustomHeading'
import CustomPagination from '../../components/CustomPagination'
import ConfirmDialog from '../../components/Dialog/ConfirmDialog'

import Layout from '../../components/Layout'
import CustomTable from '../../components/Table/CustomTable'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTableRow from '../../components/Table/CustomTableRow'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useArea } from '../../hooks/CompanyConfiguration/useArea'
import { useTotalLeave } from '../../hooks/CompanyConfiguration/useTotalLeave'
import { formatDate, handleSelectAllClick, handleSelectedItem, isSelected, ROUTES } from '../../shared/constants'
import { itemsPerPage } from '../../shared/data'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { useHistory } from 'react-router'
import { NoDataFound } from '../../components/NoDataFound'
import Loader from '../../components/Loader'

function TotalLeave() {
  const { totalLeaves } = useContext(ConfigurationContext)
  const { getAllTotalLeave, deleteTotalLeave, deleteManyTotalLeave, BulkUpload, loading, paginate } = useTotalLeave()

  // const filterTotalLeave = totalLeaves
  const [searchQuery, setSearchQuery] = useState('')

  const filterTotalLeave = totalLeaves ? totalLeaves.filter((totalLeaves) => totalLeaves && totalLeaves.leaveType && totalLeaves.leaveType.name.toLowerCase().includes(searchQuery.toLowerCase())) : []
  const [page, setPage] = React.useState(1)

  const [selected, setSelected] = React.useState([])
  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const noOfPages = paginate && paginate.totalPage
  const handleChange = (event, value) => {
    setPage(value)
  }
  //console.log('SELECTED ITEM : ', selected)
  let multipleId = []
  selected.length && selected.map((item) => multipleId.push(item._id))
  const [multipleDeleteDialog, setMultipleDeleteDialog] = React.useState(false)
  const history = useHistory()

  useEffect(() => {
    getAllTotalLeave({ page: page, limit: 10 })
  }, [page])

  return (
    <Layout
      heading="Leave Allocation"
      url={ROUTES.ADD_TOTAL_LEAVE}
      selectedData={selected}
      setDeleteDialog={setDeleteDialog}
      // deleteData={}
      editUrl={`/edit-totalLeave/${selected.length && selected[0]._id}`}
      setMultipleDeleteDialog={setMultipleDeleteDialog}
      none
      addnone
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
    >
      <CustomTable>
        {filterTotalLeave.length > 0 && (
          <CustomTableHeading
            heading={[
              <Checkbox
                indeterminate={selected.length > 0 && selected.length < filterTotalLeave.length}
                checked={filterTotalLeave.length > 0 && selected.length === filterTotalLeave.length}
                onClick={(event) => handleSelectAllClick(event, filterTotalLeave, setSelected)}
              />,
              'leave type',
              'leave allocated',
              'rank',
              'created date',
              'info',
            ]}
          />
        )}
        <TableBody>
          {!loading &&
            filterTotalLeave.length &&
            filterTotalLeave.map((item, index) => {
              const isItemSelected = isSelected(item, selected)
              return (
                <CustomTableRow

                // onClick={() => setAttendance(item)}
                >
                  <TableCell onClick={() => handleSelectedItem(item, selected, setSelected)}>
                    <Checkbox checked={isItemSelected} />
                  </TableCell>
                  <TableCell> {item.leaveType && item.leaveType.name} </TableCell>
                  <TableCell> {item.leaveAllocated} </TableCell>
                  <TableCell> {item.rank} </TableCell>

                  <TableCell> {formatDate(item.createdAt)} </TableCell>
                  <TableCell>
                    <AiOutlineInfoCircle
                      style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                      // onClick={}
                      onClick={() => history.push(`/view-totalLeave/${item._id}`)}
                    />
                  </TableCell>
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      <ConfirmDialog
        open={deleteDialog}
        handleClose={() => setDeleteDialog(false)}
        name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteTotalLeave({ totalLeaveId: selected[0]._id }, setSelected)}
      />
      <ConfirmDialog
        open={multipleDeleteDialog}
        handleClose={() => setMultipleDeleteDialog(false)}
        // name={selected.length === 1 && selected[0].name}
        handleSubmit={() => deleteManyTotalLeave({ totalLeaveId: multipleId }, setSelected)}
      />
      {!loading && filterTotalLeave.length > 0 && <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />}
      {loading && <Loader />}
      {!loading && !filterTotalLeave.length && <NoDataFound />}
    </Layout>
  )
}

export default TotalLeave
